module.exports = __webpack_public_path__ + "img/f7e069fafb242655875625e21964dde4.svg";